import React, { useId } from 'react';
import { buildWavePalette } from '../../transition';
import './NavLogoMark.css';

const DEFAULT_RING = ['#3fc4ff', '#a855f7', '#f04bd8'];

const ringStopsForAccent = (accent) => {
  if (!accent) return DEFAULT_RING;
  const palette = buildWavePalette(accent);
  return [palette[0], accent, palette[3] || palette[2]];
};

/** Elliptical ring — rear arc (passes behind the KF letters via mask). */
const RING_REAR =
  'M25.2,153.4L24.8,151.3L24.5,149.3L24.4,147.1L24.3,145.0L24.4,142.8L24.6,140.7L24.9,138.5L25.3,136.3L25.9,134.1L26.5,131.9L27.3,129.7L28.2,127.5L29.2,125.3L30.3,123.1L31.6,120.9L32.9,118.7L34.3,116.5L35.9,114.3L37.5,112.1L39.3,110.0L41.2,107.8L43.1,105.7L45.2,103.6L47.3,101.4L49.6,99.4L51.9,97.3L54.3,95.2L56.8,93.2L59.4,91.2L62.1,89.2L64.9,87.2L67.7,85.3L70.7,83.4L73.7,81.5L76.8,79.7L79.9,77.9L83.1,76.1L86.4,74.3L89.8,72.6L93.2,71.0L96.7,69.3L100.2,67.7L103.8,66.2L107.4,64.7L111.1,63.2L114.8,61.8L118.6,60.4L122.4,59.1L126.2,57.8L130.1,56.5L134.0,55.3L137.9,54.2L141.9,53.1L145.9,52.1L149.9,51.1L153.9,50.2L157.9,49.3L161.9,48.4L165.9,47.6L170.0,46.8L174.0,46.1L178.0,45.5L182.1,44.9L186.1,44.3L190.1,43.9L194.1,43.5L198.1,43.1L202.0,42.8L205.9,42.6L209.8,42.4L213.7,42.3L217.5,42.2L221.3,42.3L225.1,42.3L228.8,42.4L232.5,42.6L236.1,42.9L239.7,43.2L243.2,43.6L246.7,44.0L250.1,44.5L253.5,45.0L256.7,45.6L260.0,46.3L263.1,47.0L266.2,47.8L269.2,48.6L272.1,49.5L275.0,50.5L277.8,51.5L280.5,52.6L283.1,53.7L285.6,54.9L288.0,56.1L290.4,57.4L292.7,58.7L294.8,60.1L296.9,61.5L298.9,63.0L300.7,64.6L302.5,66.2L304.2,67.8L305.7,69.5L307.2,71.2L308.5,73.0L309.8,74.8L310.9,76.7L311.9,78.6L312.8,80.5L313.6,82.5L314.2,84.5L314.8,86.6L309.7,87.7L309.3,86.0L308.7,84.3L308.1,82.5L307.3,80.9L306.4,79.2L305.4,77.6L304.4,76.0L303.2,74.4L301.9,72.8L300.5,71.3L299.0,69.8L297.4,68.4L295.7,67.0L293.9,65.6L292.0,64.2L290.0,62.9L287.9,61.7L285.7,60.4L283.5,59.3L281.1,58.1L278.6,57.0L276.0,56.0L273.4,55.0L270.7,54.1L267.9,53.2L265.0,52.3L262.0,51.5L259.0,50.8L255.8,50.1L252.7,49.5L249.4,48.9L246.1,48.4L242.7,47.9L239.3,47.5L235.8,47.2L232.2,46.9L228.6,46.7L225.0,46.5L221.3,46.4L217.5,46.4L213.8,46.4L210.0,46.4L206.1,46.5L202.2,46.7L198.3,47.0L194.4,47.3L190.5,47.6L186.5,48.0L182.6,48.5L178.6,49.0L174.6,49.6L170.6,50.3L166.6,51.0L162.6,51.7L158.6,52.5L154.6,53.4L150.7,54.4L146.7,55.4L142.8,56.5L138.9,57.6L135.0,58.8L131.2,60.0L127.4,61.3L123.6,62.6L119.9,63.9L116.2,65.3L112.5,66.8L108.9,68.3L105.3,69.8L101.8,71.4L98.4,73.0L95.0,74.6L91.7,76.3L88.4,78.0L85.2,79.8L82.0,81.6L79.0,83.4L76.0,85.2L73.1,87.1L70.2,89.0L67.5,90.9L64.8,92.9L62.2,94.8L59.7,96.8L57.3,98.8L55.0,100.8L52.7,102.8L50.6,104.9L48.6,106.9L46.6,109.0L44.8,111.0L43.0,113.1L41.4,115.1L39.9,117.2L38.4,119.3L37.1,121.3L35.9,123.4L34.8,125.4L33.8,127.4L32.8,129.5L32.0,131.5L31.4,133.5L30.8,135.4L30.3,137.4L29.9,139.3L29.7,141.2L29.5,143.1L29.4,145.0L29.5,146.9L29.6,148.7L29.9,150.5L30.3,152.3Z';

/** Elliptical ring — front arc (passes in front of the letters). */
const RING_FRONT =
  'M314.8,86.6L315.2,88.7L315.5,90.7L315.6,92.9L315.7,95.0L315.6,97.2L315.4,99.3L315.1,101.5L314.7,103.7L314.1,105.9L313.5,108.1L312.7,110.3L311.8,112.5L310.8,114.7L309.7,116.9L308.4,119.1L307.1,121.3L305.7,123.5L304.1,125.7L302.5,127.9L300.7,130.0L298.8,132.2L296.9,134.3L294.8,136.4L292.7,138.6L290.4,140.6L288.1,142.7L285.7,144.8L283.2,146.8L280.6,148.8L277.9,150.8L275.1,152.8L272.3,154.7L269.3,156.6L266.3,158.5L263.2,160.3L260.1,162.1L256.9,163.9L253.6,165.7L250.2,167.4L246.8,169.0L243.3,170.7L239.8,172.3L236.2,173.8L232.6,175.3L228.9,176.8L225.2,178.2L221.4,179.6L217.6,180.9L213.8,182.2L209.9,183.5L206.0,184.7L202.1,185.8L198.1,186.9L194.1,187.9L190.1,188.9L186.1,189.8L182.1,190.7L178.1,191.6L174.1,192.4L170.0,193.2L166.0,193.9L162.0,194.5L157.9,195.1L153.9,195.7L149.9,196.1L145.9,196.5L141.9,196.9L138.0,197.2L134.1,197.4L130.2,197.6L126.3,197.7L122.5,197.8L118.7,197.7L114.9,197.7L111.2,197.6L107.5,197.4L103.9,197.1L100.3,196.8L96.8,196.4L93.3,196.0L89.9,195.5L86.5,195.0L83.3,194.4L80.0,193.7L76.9,193.0L73.8,192.2L70.8,191.4L67.9,190.5L65.0,189.5L62.2,188.5L59.5,187.4L56.9,186.3L54.4,185.1L52.0,183.9L49.6,182.6L47.3,181.3L45.2,179.9L43.1,178.5L41.1,177.0L39.3,175.4L37.5,173.8L35.8,172.2L34.3,170.5L32.8,168.8L31.5,167.0L30.2,165.2L29.1,163.3L28.1,161.4L27.2,159.5L26.4,157.5L25.8,155.5L25.2,153.4L30.3,152.3L30.7,154.0L31.3,155.7L31.9,157.5L32.7,159.1L33.6,160.8L34.6,162.4L35.6,164.0L36.8,165.6L38.1,167.2L39.5,168.7L41.0,170.2L42.6,171.6L44.3,173.0L46.1,174.4L48.0,175.8L50.0,177.1L52.1,178.3L54.3,179.6L56.5,180.7L58.9,181.9L61.4,183.0L64.0,184.0L66.6,185.0L69.3,185.9L72.1,186.8L75.0,187.7L78.0,188.5L81.0,189.2L84.2,189.9L87.3,190.5L90.6,191.1L93.9,191.6L97.3,192.1L100.7,192.5L104.2,192.8L107.8,193.1L111.4,193.3L115.0,193.5L118.7,193.6L122.5,193.6L126.2,193.6L130.0,193.6L133.9,193.5L137.8,193.3L141.7,193.0L145.6,192.7L149.5,192.4L153.5,192.0L157.4,191.5L161.4,191.0L165.4,190.4L169.4,189.7L173.4,189.0L177.4,188.3L181.4,187.5L185.4,186.6L189.3,185.6L193.3,184.6L197.2,183.5L201.1,182.4L205.0,181.2L208.8,180.0L212.6,178.7L216.4,177.4L220.1,176.1L223.8,174.7L227.5,173.2L231.1,171.7L234.7,170.2L238.2,168.6L241.6,167.0L245.0,165.4L248.3,163.7L251.6,162.0L254.8,160.2L258.0,158.4L261.0,156.6L264.0,154.8L266.9,152.9L269.8,151.0L272.5,149.1L275.2,147.1L277.8,145.2L280.3,143.2L282.7,141.2L285.0,139.2L287.3,137.2L289.4,135.1L291.4,133.1L293.4,131.0L295.2,129.0L297.0,126.9L298.6,124.9L300.1,122.8L301.6,120.7L302.9,118.7L304.1,116.6L305.2,114.6L306.2,112.6L307.2,110.5L308.0,108.5L308.6,106.5L309.2,104.6L309.7,102.6L310.1,100.7L310.3,98.8L310.5,96.9L310.6,95.0L310.5,93.1L310.4,91.3L310.1,89.5L309.7,87.7Z';

const LETTER_PATHS = [
  'M64,62L86,62L86,178L64,178Z',
  'M86,104L130,62L156,62L112,104Z',
  'M112,104L152,178L177,178L128.5,88.25Z',
  'M190,62L212,62L212,178L190,178Z',
  'M212,62L276,62L276,78L212,78Z',
  'M212,108L264,108L264,124L212,124Z',
];

/**
 * KF monogram with prism ring + orb that orbits on hover.
 * Pass `accent` on project routes so the ring / orb match the case-study brand.
 */
function NavLogoMark({ className, accent = null }) {
  const reactId = useId();
  const uid = reactId.replace(/:/g, '');
  const ringId = `kfRing-${uid}`;
  const inkId = `kfInk-${uid}`;
  const fadeId = `kfFade-${uid}`;
  const maskId = `kfBehind-${uid}`;
  const bloomId = `kfBloom-${uid}`;
  const fatId = `kfFat-${uid}`;

  const ringStops = ringStopsForAccent(accent);

  const ringPaint = {
    fill: `url(#${ringId})`,
    stroke: `url(#${ringId})`,
    strokeWidth: 3,
    strokeLinejoin: 'round',
  };

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 340 240"
      role="img"
      aria-hidden
      data-project-accent={accent || undefined}
      style={
        accent
          ? {
              '--nav-project-accent': accent,
              '--kf-orb': accent,
              color: accent,
            }
          : undefined
      }
    >
      <defs>
        <linearGradient
          id={ringId}
          gradientUnits="userSpaceOnUse"
          x1="26.9"
          y1="0"
          x2="313.1"
          y2="0"
        >
          <stop offset="0" stopColor={ringStops[0]} />
          <stop offset="0.5" stopColor={ringStops[1]} />
          <stop offset="1" stopColor={ringStops[2]} />
        </linearGradient>
        <linearGradient
          id={inkId}
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="62"
          x2="0"
          y2="178"
        >
          <stop offset="0" stopColor="var(--kf-ink-a, #ffffff)" />
          <stop offset="1" stopColor="var(--kf-ink-b, #c8e2fa)" />
        </linearGradient>
        <linearGradient
          id={fadeId}
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="44"
          x2="0"
          y2="146"
        >
          <stop offset="0" stopColor="#5a5a5a" />
          <stop offset="1" stopColor="#ffffff" />
        </linearGradient>
        <mask
          id={maskId}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="340"
          height="240"
        >
          <rect width="340" height="240" fill={`url(#${fadeId})`} />
          {/* Knock out the letter silhouettes so the rear arc reads as behind KF */}
          <g
            fill="#000"
            stroke="#000"
            strokeWidth="18"
            strokeLinejoin="round"
            transform="translate(170 120) scale(0.9) translate(-170 -120)"
          >
            {LETTER_PATHS.map((d) => (
              <path key={d} d={d} />
            ))}
          </g>
        </mask>
        <filter
          id={bloomId}
          x="-30%"
          y="-40%"
          width="160%"
          height="180%"
        >
          <feGaussianBlur stdDeviation="6.5" />
        </filter>
        {/* Dilate so the ribbon stays readable at navbar scale */}
        <filter id={fatId} x="-35%" y="-45%" width="170%" height="190%">
          <feMorphology operator="dilate" radius="1.7" in="SourceGraphic" result="wide" />
          <feMerge>
            <feMergeNode in="wide" />
          </feMerge>
        </filter>
      </defs>

      <g className="kf-bloom" filter={`url(#${bloomId})`}>
        <path d={RING_REAR} {...ringPaint} mask={`url(#${maskId})`} />
        <path d={RING_FRONT} {...ringPaint} />
      </g>

      <g filter={`url(#${fatId})`}>
        <path d={RING_REAR} {...ringPaint} mask={`url(#${maskId})`} />
      </g>

      {/* Slightly smaller KF so the front arc clearly crosses the letterforms */}
      <g
        fill={`url(#${inkId})`}
        transform="translate(170 120) scale(0.9) translate(-170 -120)"
      >
        {LETTER_PATHS.map((d) => (
          <path key={`ink-${d}`} d={d} />
        ))}
      </g>

      <g filter={`url(#${fatId})`}>
        <path d={RING_FRONT} {...ringPaint} />
      </g>

      {/* One traveler owns the orbit so sparkle always sits on the orb */}
      <g className="kf-traveler" transform="translate(291.80,136.11)">
        <g className="kf-orb">
          <circle className="kf-orbCore" r="14" />
          <circle className="kf-orbHighlight" r="5.5" fill="#fff3fb" />
        </g>
        <g className="kf-sparkle" aria-hidden="true">
          <circle className="kf-sparkleGlow" r="10" />
          <path
            className="kf-sparkleRay"
            fill="#ffffff"
            d="M0,-20 L2,-2 L20,0 L2,2 L0,20 L-2,2 L-20,0 L-2,-2 Z"
          />
          <path
            className="kf-sparkleRay"
            fill="#ffffff"
            d="M0,-11 L1.2,-1.2 L11,0 L1.2,1.2 L0,11 L-1.2,1.2 L-11,0 L-1.2,-1.2 Z"
            transform="rotate(45)"
            opacity="0.92"
          />
          <circle className="kf-sparkleCore" r="3.2" fill="#ffffff" />
        </g>
      </g>
    </svg>
  );
}

export default NavLogoMark;
